module.exports = __webpack_public_path__ + "img/6.d43d5fe0.webp";